export default {
  form: {
    customerName: '',
    opportunityId: '',
    awsAccountIds: '',
    supportingPdl: '',
    contactEmail: '',
    contactName: '',
    requestManagedServices: false,
    wbsCode: '',
    targetDeploymentDate: '',
    customizationDescription: ''
  },
  formErrors: {},
  isSubmitting: false,
  submitError: null,
  submitSuccess: false,
  requests: [],
  selectedRequest: null,
  isLoading: false,
  nextPageKey: null,
  isValidatingOppId: false,
  oppIdValidated: false,
  oppIdData: null,
  regions: [
    {
      label: 'us-east-1 (N. Virginia)',
      value: 'us-east-1'
    },
    {
      label: 'us-east-2 (Ohio)',
      value: 'us-east-2'
    },
    {
      label: 'us-west-1 (N. California)',
      value: 'us-west-1'
    },
    {
      label: 'us-west-2 (Oregon)',
      value: 'us-west-2'
    },
    {
      label: 'us-gov-west-1 (US GovCloud West)',
      value: 'us-gov-west-1'
    },
    {
      label: 'us-gov-east-1 (US GovCloud East)',
      value: 'us-gove-east-1'
    },
    {
      label: 'ca-central-1 (Canada)',
      value: 'ca-central-1'
    },
    {
      label: 'eu-north-1 (Stockholm)',
      value: 'eu-north-1'
    },
    {
      label: 'eu-west-1 (Ireland)',
      value: 'eu-west-1'
    },
    {
      label: 'eu-west-2 (London)',
      value: 'eu-west-2'
    },
    {
      label: 'eu-west-3 (Paris)',
      value: 'eu-west-3'
    },
    {
      label: 'eu-central-1 (Frankfurt)',
      value: 'eu-central-1'
    },
    {
      label: 'eu-south-1 (Milan)',
      value: 'eu-south-1'
    },
    {
      label: 'af-south-1 (Cape Town)',
      value: 'af-south-1'
    },
    {
      label: 'ap-northeast-1 (Tokyo)',
      value: 'ap-northeast-1'
    },
    {
      label: 'ap-northeast-2 (Seoul)',
      value: 'ap-northeast-2'
    },
    {
      label: 'ap-northeast-3 (Osaka)',
      value: 'ap-northeast-3'
    },
    {
      label: 'ap-southeast-1 (Singapore)',
      value: 'ap-southeast-1'
    },
    {
      label: 'ap-southeast-2 (Sydney)',
      value: 'ap-southeast-2'
    },
    {
      label: 'ap-east-1 (Hong Kong)',
      value: 'ap-east-1'
    },
    {
      label: 'ap-south-1 (Mumbai)',
      value: 'ap-south-1'
    },
    {
      label: 'me-south-1 (Bahrain)',
      value: 'me-south-1'
    },
    {
      label: 'sa-east-1 (São Paulo)',
      value: 'sa-east-1'
    },
    {
      label: 'cn-north-1 (Bejing)',
      value: 'cn-north-1'
    },
    {
      label: 'cn-northwest-1 (Ningxia)',
      value: 'cn-northwest-1'
    },
    {
      label: 'ap-southeast-3 (Jakarta)',
      value: 'ap-southeast-3'
    }
  ],
  accountListHeaders: [
    {
      text: 'Actions',
      value: 'actions',
      align: 'start',
      sortable: false
    },
    {
      text: 'Client owned AWS Account ID',
      value: 'aws_account_id'
    }
  ],
}
